
export const siteConstants = {
    theOpen: 'TheOpen',
    womensOpen: 'WomensOpen',
};
